import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import GrangerTestGraph from './GrangerTestGraph';
import GrangerHeatmapChart from './GrangerHeatmapChart';
import { ReactComponent as FlowChart } from './FlowChart.svg';

const GrangerTestComponent = (props) => {
  const [activeTab, setActiveTab] = useState('1');

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  }

  return (
    <div class="container">
      <h3>Granger Casuality Test</h3>
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '1' })}
            onClick={() => { toggle('1'); }}>
            Correlation Graph
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '2' })}
            onClick={() => { toggle('2'); }}>
            Heatmap
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1" style={{ 'padding-top': '20px' }}>
          <GrangerTestGraph />
          <p>
            Labels on the edges represent <i>p</i>-values of the Granger casuality test.
            A directed edge from <i>x</i> to <i>y</i> means <i>x</i> Granger-causes <i>y</i>.
          </p>
        </TabPane>
        <TabPane tabId="2" style={{ 'padding-top': '20px' }}>
          <GrangerHeatmapChart />
        </TabPane>
      </TabContent>
      <hr />
      <p>
        We used the following steps for the Granger Casuality test procedure:
      </p>
      <FlowChart style={{ padding: '5px 0 15px 0', height: '40%', display: 'block', margin: 'auto' }} />
      <ol>
        <li>
          Run Augmented Dickey-Fuller test for each time series using&nbsp;
        <a href="https://www.rdocumentation.org/packages/tseries/versions/0.10-48/topics/adf.test">
            <code>adf.test</code></a> in R. We believe that the null hypothesis (<i>H<sub>0</sub></i>)
            can be rejected when <i>p</i>-value &lt; 0.05, which means the series has no unit root (stationary).
            If we cannot reject <i>H<sub>0</sub></i>, which means the series has unit root (non-stationary),
            then differencing transformation will be applied to the series until rejected the null hypothesis.
        </li>
        <li>
          Run KPSS test for each time series using&nbsp;
        <a href="https://www.rdocumentation.org/packages/tseries/versions/0.10-48/topics/kpss.test">
            <code>kpss.test</code></a> in R, the null hypothesis (<i>H<sub>0</sub></i>) is level stationary
            rather than trend stationary. We believe that the null hypothesis can be rejected when <i>p</i>-value
            &lt; 0.1. If we reject <i>H<sub>0</sub></i>, which means the series is non-stationary,
            then differencing transformation will be applied to the series until rejected the null hypothesis.
        </li>
        <li>
          Run Granger Casuality test for each two time series in two directions using&nbsp;
        <a href="https://www.rdocumentation.org/packages/lmtest/versions/0.9-38/topics/grangertest">
            <code>grangertest</code></a> in R, with the order of lags 2.
        </li>
      </ol>
    </div>
  );
}

export default GrangerTestComponent;